import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading-inner',
  templateUrl: './loading-inner.component.html',
  styleUrls: ['./loading-inner.component.scss']
})
export class LoadingInnerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
